<div class="landing-toolbar">
  <button
    mat-icon-button
    type="button"
    class="landing-toolbar__btn"
    [matMenuTriggerFor]="languageMenu"
    [matTooltip]="'landing.toolbar.language' | translate"
    [attr.aria-label]="'landing.toolbar.language' | translate">
    <img
      class="landing-toolbar__flag"
      [src]="selectedLanguage().icon"
      [alt]="selectedLanguage().language" />
  </button>

  <mat-menu
    #languageMenu="matMenu"
    class="cardWithShadow landing-toolbar__language-menu"
    xPosition="before">
    @for (language of languages; track language.code) {
    <button mat-menu-item type="button" (click)="changeLanguage(language)">
      <div class="landing-toolbar__language-option">
        <img class="landing-toolbar__flag" [src]="language.icon" [alt]="language.language" />
        <span>{{ language.language }}</span>
      </div>
    </button>
    }
  </mat-menu>

  @if (theme() === "light") {
  <button
    mat-icon-button
    type="button"
    class="landing-toolbar__btn"
    (click)="setTheme('dark')"
    [matTooltip]="'landing.toolbar.theme_dark' | translate"
    [attr.aria-label]="'landing.toolbar.theme_dark' | translate">
    <i-tabler name="moon" class="landing-toolbar__icon"></i-tabler>
  </button>
  } @else {
  <button
    mat-icon-button
    type="button"
    class="landing-toolbar__btn"
    (click)="setTheme('light')"
    [matTooltip]="'landing.toolbar.theme_light' | translate"
    [attr.aria-label]="'landing.toolbar.theme_light' | translate">
    <i-tabler name="sun" class="landing-toolbar__icon"></i-tabler>
  </button>
  }
</div>
